import React, {FC} from 'react';
import styled from 'styled-components';

const LabelText = styled.div`
    border: none;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    transform-origin: 0 0;
    transition: all 0.2s;
`;

const Input = styled.input`
    && {
        border: none;
        outline: none;
    }

    &:focus,
    &:not(:placeholder-shown) {
        + ${LabelText} {
            opacity: 0.65;
            transform: scale(0.85) translateY(-0.625em) translateX(4px);
        }
    }
`;

const Container = styled.label`
    padding-top: 1.125em !important;
    padding-bottom: 0.375em !important;
    position: relative;
`;

export type TProps = {
    label: string;
    type?: string;
    name: string;
    value: string;
    setValue: React.Dispatch<React.SetStateAction<string>>;
    isRequired?: boolean;
}

const TextInput: FC<TProps> = ({label, type = 'text', name, value, setValue, isRequired}) => {
    return (
        <Container className="cr-pill cr-border-primary">
            <Input
                className="cr-text-base cr-w-100"
                type={type}
                name={name}
                value={value}
                placeholder=" "
                required={isRequired}
                onChange={(event) => setValue(event.target.value)}
            />
            <LabelText className="cr-pill cr-border-transparent">
                {label}
            </LabelText>
        </Container>
    );
};

export default TextInput;
